import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { UserLiftPermissionService } from 'src/app/user/services/usr-lift-permission.service';
import { LiftStateService } from './lift-state.service';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class LiftStateResolver implements Resolve<any> {
  constructor(
    private liftStateService: LiftStateService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    const liftId = route.params.id;
    const params: HttpParams = new HttpParams();

    return this.liftStateService.getState(liftId, params);
  }
}
